import React from "react";
import {WithTranslation, withTranslation} from "react-i18next";
import {Icon} from 'antd';
import {IdentityProps, isInRole, withIdentity} from 'src/core/services/authentication';
import EditableTooltip from "./editable-tooltip";
import {withUserProfile} from "../user-profile";

interface TooltipProps extends WithTranslation, IdentityProps {
    name: string;
    placement?: string;
    visible?: boolean
    iconColor?: string
    noIcon?: boolean
    onClickIcon?: ()=>void
}

class Tooltip extends React.Component<TooltipProps> {
    public render() {
        const { visible, placement, iconColor, children, name, t, tReady, i18n, identity } = this.props;
        
        return (
            <>
                <EditableTooltip
                    name={name}
                    visible={visible}
                    editable={isInRole(identity, ["Manager", "Administrator", "ClientAdmin", "FIConsultant"])}
                    placement={placement}
                    t={t}
                    i18n={i18n}
                    tReady={tReady}
                >
                    {children}
                    {!this.props.noIcon &&
                        <Icon type="info-circle" style={{ fontSize: '14px', color: iconColor || 'grey', marginRight: 5, marginLeft: 5 }} onClick={this.props.onClickIcon ? this.props.onClickIcon : undefined} />
                    }
                </EditableTooltip>
            </>
        );
    }
}

export default withUserProfile(withIdentity(withTranslation()(Tooltip) as any))